import * as React from 'react';
import { useDynamicData, useStaticData } from '@avensia/excite';
import { styled } from '@glitz/react';
import BaseImage from 'webapp/components/image';
import { Block, edgeMarginsDecorator, maxContentNormalWidthDecorator } from 'webapp/components/page-layout';
import { createMaxSmallViewportDecorator, createMinLargeViewportDecorator } from 'webapp/viewport';
import { TrustyShops } from './Trustyshops';
import { bareListDecorator } from 'webapp/decorators/list';

export default function InfoFooter() {
  const infoFooter = useStaticData<NordicNest.Api.FooterApiModel>();
  const paymentLogos = infoFooter?.paymentLogos || [];
  const trustedCommerceLogo = infoFooter?.trustedCommerceLogo;

  return (
    <Base>
      <Container>
        <Icons>
          <TrustyShops />
          {trustedCommerceLogo ? (
            <li key={'TrustedCommerceLogo'}>
              <Image image={trustedCommerceLogo} className={'TEH_LOGOTYPE'} id="TEH_LOGOTYPE" />
            </li>
          ) : null}
          {paymentLogos.map((logo, i) => (
            <li key={i}>
              <Image image={logo} />
            </li>
          ))}
        </Icons>
        <Text>{infoFooter?.address}</Text>
        <Text>{infoFooter?.copyright}</Text>
      </Container>
    </Base>
  );
}

const Base = styled.footer({
  backgroundColor: t => t.footer?.infoFooter?.color,
  color: t => t.footer?.infoFooter?.text,
  padding: { y: t => t.spacing.xl },
});

const Icons = styled.ul(
  bareListDecorator,
  createMaxSmallViewportDecorator({
    padding: { x: t => t.spacing.xs },
  }),
  {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: t => t.spacing.m,
  },
);

const Text = styled.div({
  fontSize: t => t.fontSize.xxs,
  width: '100%',
  textAlign: 'center',
  margin: { top: t => t.spacing.l },
});

const Container = styled(
  Block,
  maxContentNormalWidthDecorator,
  edgeMarginsDecorator,
  createMinLargeViewportDecorator({ minHeight: 100 }),
  {
    alignItems: 'center',
    justifyContent: 'center',
  },
);

const Image = styled(BaseImage, {
  maxHeight: 48,
});
